import APIClient, { ErrorCode, ErrorMessage } from '@/api/APIClient'

export const Coupon = {
  namespaced: true,
  state: {
    coupons: [],
    coupon: null,
    couponType: '0',
    gift_url: null,
    weborder_url: null,
    expire_coupon:0,
    expire_freepass:0
  },
  getters: {
    coupons: state => state.coupons, // クーポンリスト
    coupon: state => state.coupon, // クーポン詳細
    couponType: state => state.couponType, // クーポンタイプ
    gift_url: state => state.gift_url,
    expire_coupon: state => state.expire_coupon,
    expire_freepass: state => state.expire_freepass,
    weborder_url: state => state.weborder_url
  },
  mutations: {
    UPDATE_COUPON(state, payload) {
      state.coupons = payload
    },
    UPDATE_COUPON_DETAIL(state, payload) {
      console.log(payload)
      state.coupon = payload.data
      state.couponType = payload.type
    },
    SET_GIFTEE(state, payload) {
      state.gift_url = payload.gift_url
    },
    SET_WEBORDER(state, payload) {
      state.weborder_url = payload.weborder_url
    },
    UPDATE_IS_EXPIRE_COUPON(state, payload) {
      state.expire_coupon = payload
    },
    UPDATE_IS_EXPIRE_FREEPASS(state, payload) {
      state.expire_freepass = payload
    }
  },
  actions: {
    /**
     * クーポンの取得
     *
     * @param {object} context
     * @param {object} context.commit
     * @param {object} payload
     */
    async actionFetchCoupon({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getCouponList(token, accTime, userId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_COUPON', res.data.data['coupon_data']['coupons'])
        const coupon_array = res.data.data['coupon_data']['coupons']
        let is_expire_coupon = 0
        let is_expire_freepass = 0
        commit('UPDATE_IS_EXPIRE_COUPON', 0)
        commit('UPDATE_IS_EXPIRE_FREEPASS', 0)
        coupon_array.forEach(part => {
          const array = part.data.expire_at.split(' ')
          const dateStr = array[0].split('-').join('/')
          const date1 = new Date(Date.now())
          const date2 = new Date(dateStr)
          if ((date2 - date1) / 86400000 < 7) {
            if (part.data.prize_type !== '0') {
              commit('UPDATE_IS_EXPIRE_FREEPASS', 1)
            }
            if (part.data.prize_type === '0') {
              commit('UPDATE_IS_EXPIRE_COUPON', 1)
            }
          }
        })
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    },
    /**
     * クーポン詳細データ取得
     *
     * @param {object} context
     * @param {object} context.commit
     * @param {string} payload
     */
    async actionFetchCouponDetail({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const couponId = payload.couponId
      const accTime = payload.accTime
      let res = null
      if (token !== '') {
        res = await APIClient.getCouponDetails(token, accTime, userId, couponId)
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      console.log(res)
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        commit('UPDATE_COUPON_DETAIL', res.data.data['coupon_data']['coupons'])
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    },
    /**
     * クーポン利用を送信
     *
     * @param {object} context
     * @param {object} context.commit
     * @param {string} payload
     */
    async actionRequestUseCoupon({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const couponId = payload.couponId
      const accTime = payload.accTime
      const isWeborder = payload.isWeborder
      let res = null
      console.log(token)
      // const error = { code: '234234234', message: payload }
      // throw error
      if (token !== '') {
        res = await APIClient.postUseCoupon(
          token,
          accTime,
          userId,
          couponId,
          isWeborder
        )
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }

      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        if (res.data.data.gift_url !== '') {
          commit('SET_GIFTEE', res.data.data)
        }
        if (res.data.data.weborder_url) {
          commit('SET_WEBORDER', res.data.data)
        }
        console.log('クーポン利用OKです。')
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    },
    /**
     * 特典の利用を送信
     *
     * @param {object} context
     * @param {object} context.commit
     */
    async actionRequestExchangePrize({ commit }, payload) {
      const token = payload.token
      const userId = payload.userId
      const prizeId = payload.prizeId
      const accTime = payload.accTime
      const isWeborder = payload.isWeborder

      let res = null
      if (token !== '') {
        res = await APIClient.postExchangePrize(
          token,
          accTime,
          userId,
          prizeId,
          isWeborder
        )

        if (res.data.data.weborder_url) {
          commit('SET_WEBORDER', res.data.data)
        }
      } else {
        const error = {
          code: ErrorCode.CODE_ERROR_TOKEN,
          message: ErrorMessage.MSG_ERROR_TOKEN
        }
        throw error
      }
      console.log(res)
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        console.log('特典利用OKです。')
      } else {
        const error = {
          code: res.data.data.code,
          message: res.data.data.message
        }
        throw error
      }
    }
  }
}
